import React from 'react';
import '../App.css';
import { Headerappsa } from './/headerappsa'
import { Bodyapploginsabody} from './/bodyapploginsabody'
import { Footerapp } from './/footerapp'

export class Bodyapploginsa extends React.Component {
  constructor(props) {
    super(props);
}
state = {
    apiKey:''
}  
  render(){
    return (
      <div className="App">        
        <Headerappsa/>
        <Bodyapploginsabody/>
        <Footerapp/>
      </div>
    );
  }
}
